// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"d8348882","142":"0e360c99","811":"2ebb8435","855":"c22105be"}[chunkId] + ".chunk.css";
};